export const getGeocodableEntityId = entity =>
  entity?.public_id ?? entity?.id ?? entity?.identifier ?? entity?.building_id ?? entity?.code;

export const hasGeocodableAddress = address => Boolean(address?.street && address?.city && address?.state);

const getNestedAccessInformation = accessInformation =>
  [
    accessInformation,
    accessInformation?.accessInformation,
    accessInformation?.propertyAccess,
    accessInformation?.access_information,
    accessInformation?.property_access,
  ].filter(Boolean);

export const getOrderAccessInformation = order => {
  const accessInformation = [
    order?.access_information,
    order?.accessInformation,
    order?.property_access,
    order?.propertyAccess,
    order?.details?.access_information,
    order?.details?.accessInformation,
    order?.details?.property_access,
    order?.details?.propertyAccess,
  ].flatMap(getNestedAccessInformation);

  return [...new Set(accessInformation)];
};

export const getAccessInformationValue = (accessInformation, key) =>
  accessInformation?.[key] ??
  accessInformation?.accessInformation?.[key] ??
  accessInformation?.propertyAccess?.[key] ??
  accessInformation?.access_information?.[key] ??
  accessInformation?.property_access?.[key];

export const getAccessInformationAddress = accessInformation => {
  const addressCandidates = [
    getAccessInformationValue(accessInformation, 'address'),
    getAccessInformationValue(accessInformation, 'locationAddress'),
    getAccessInformationValue(accessInformation, 'keysAddress'),
    accessInformation,
  ];

  return addressCandidates.find(hasGeocodableAddress) || null;
};

export const getKeysDevolutionAddress = accessInformation => {
  const address = getAccessInformationValue(accessInformation, 'keysDevolutionAddress');

  return hasGeocodableAddress(address) ? address : null;
};

export const getKeyPickupAddress = order => {
  const accessInfo =
    order?.access_information ||
    order?.accessInformation ||
    order?.details?.access_information ||
    order?.details?.accessInformation;

  const accessType = accessInfo?.type;
  if (['No local', 'Local'].includes(accessType)) {
    return null;
  }

  if (accessInfo?.address && hasGeocodableAddress(accessInfo.address)) {
    return accessInfo.address;
  }

  return null;
};

export const getKeyReturnAddress = order => {
  const accessInfo =
    order?.access_information ||
    order?.accessInformation ||
    order?.details?.access_information ||
    order?.details?.accessInformation;

  const devType = accessInfo?.keysDevolutionType || accessInfo?.keys_devolution_type;

  if (['No local', 'Local'].includes(devType)) {
    return null;
  }

  if (devType === 'Outro' && accessInfo?.keysDevolutionAddress && hasGeocodableAddress(accessInfo.keysDevolutionAddress)) {
    return accessInfo.keysDevolutionAddress;
  }

  if (devType === 'Mesmo local da retirada' || !devType) {
    return getKeyPickupAddress(order);
  }

  if (accessInfo?.keysDevolutionAddress && hasGeocodableAddress(accessInfo.keysDevolutionAddress)) {
    return accessInfo.keysDevolutionAddress;
  }

  return null;
};
